module.exports = __webpack_public_path__ + "img/logoMen.337ca7b8.jpg";